<p-select (ngModelChange)="changeLang($event)" *ngIf="translate.getLangs() && translate.getLangs().length > 1"
          [ngModel]="translate.getDefaultLang()" [options]="translate.getLangs()"
          placeholder="{{ 'Choisir une langue' | translate }}" appendTo="body">
	<ng-template let-lang pTemplate="item">{{ 'lang.' + lang | translate }}</ng-template>
	<ng-template let-lang pTemplate="selectedItem">{{ 'lang.' + lang | translate }}</ng-template>
</p-select>
